import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const HeroSection = () => {
  const { userSession } = useAuth(); // Get session from context

  const userType = userSession?.userType;

  const isSignedIn = userType === "applicator";

  return (
    <section className="tw-relative tw-pt-52 md:tw-pt-44 tw-min-h-screen tw-w-full tw-flex tw-items-center tw-justify-center tw-text-white tw-text-center tw-px-4 tw-py-16">
      {/* Video Background */}
      <video
        className="tw-w-full tw-h-full tw-object-cover tw-absolute tw-inset-0 -tw-z-10"
        src="https://www.sippamericas.com/wp-content/uploads/2021/05/Induracoat-liningvideo-ForWeb.mp4"
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
      />

      {/* Dark Overlay */}
      <div className="tw-absolute tw-inset-0 tw-bg-black/60 -tw-z-10" />

      <div className="tw-max-w-7xl tw-w-full -tw-mt-24">
        {/* Main Heading */}
        <h1 className="tw-text-3xl  md:tw-text-4xl lg:tw-text-5xl tw-font-bold tw-uppercase tw-mb-12">
          Spray-in-Place Pipe Rehabilitation
        </h1>

        {/* Grid for Applicator and Non-Applicator */}
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-1 tw-gap-10">
          {/* Replace with this when you turn on Non applicator: md:tw-grid-cols-2  */}
          {/* Applicator Section */}
          <div className="tw-bg-white/10 tw-backdrop-blur-md tw-rounded-xl tw-p-6 tw-flex tw-flex-col tw-justify-between tw-h-full">
            {isSignedIn ? (
              <div>
                <h2 className="tw-text-2xl sm:tw-text-2xl md:tw-text-3xl tw-font-semibold tw-mb-2">
                  Hello,{" "}
                  <span className="tw-text-2xl sm:tw-text-2xl md:tw-text-3xl tw-font-semibold tw-mb-2">
                    {userSession.firstName}
                  </span>
                </h2>
                <p className="tw-mb-6 tw-text-base sm:tw-text-lg md:tw-text-xl">
                  Applicators are SIPP Americas LLC approved and in good
                  standing licensees.
                </p>
              </div>
            ) : (
              <div>
                <h2 className="tw-text-2xl sm:tw-text-2xl md:tw-text-3xl tw-font-semibold tw-mb-2">
                  Are you an Applicator?
                </h2>
                <p className="tw-mb-6 tw-text-base sm:tw-text-lg md:tw-text-xl">
                  Applicators are SIPP Americas LLC approved and in good
                  standing licensees.
                </p>
              </div>
            )}
            {isSignedIn ? (
              <Link to="/projectlist">
                <button className="tw-bg-[#00B5ED] tw-text-white tw-px-6 tw-py-3 tw-rounded-full tw-font-semibold tw-w-full hover:tw-scale-105 tw-transition-transform tw-text-lg md:tw-text-xl">
                  Manage Projects
                </button>
              </Link>
            ) : (
              <Link to="/register">
                <button className="tw-bg-[#00B5ED] tw-text-white tw-px-6 tw-py-3 tw-rounded-full tw-font-semibold tw-w-full hover:tw-scale-105 tw-transition-transform tw-text-lg md:tw-text-xl">
                  Register as an Applicator
                </button>
              </Link>
            )}
          </div>

          {/* Non-Applicator Section */}
          {/* <div className="tw-bg-white/10 tw-backdrop-blur-md tw-rounded-xl tw-p-6 tw-flex tw-flex-col tw-justify-between tw-h-full">
            <div>
              <h2 className="tw-text-xl sm:tw-text-2xl md:tw-text-3xl tw-font-semibold tw-mb-2">
                Are you a Non-Applicator?
              </h2>
              <p className="tw-mb-6 tw-text-base sm:tw-text-lg md:tw-text-xl">
                Non-Applicators are pipe network system owners (e.g. water
                utilities, industrial), and industry professionals (engineers,
                technicians, etc.) involved in or interested in completing SIPP
                Americas LLC lining projects.
              </p>
            </div>
            <Link to="/signup">
              <button className="tw-bg-[#00B5ED] tw-text-white tw-px-6 tw-py-3 tw-rounded-full tw-font-semibold tw-w-full hover:tw-scale-105 tw-transition-transform tw-text-lg md:tw-text-xl">
                Register as a Non-Applicator
              </button>
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
